<template>
  <div class="architecture" aria-hidden="true">
    <svg viewBox="0 0 700 950" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="facade" x1="0" x2="1" y1="0" y2=".25"><stop stop-color="#656865"/><stop offset=".6" stop-color="#292d2b"/><stop offset="1" stop-color="#080b0a"/></linearGradient>
        <linearGradient id="shadow" x1="0" y1="0" x2="0" y2="1"><stop stop-color="#000" stop-opacity=".05"/><stop offset="1" stop-color="#000" stop-opacity=".85"/></linearGradient>
        <pattern id="grain" width="5" height="5" patternUnits="userSpaceOnUse"><circle cx="1" cy="1" r=".5" fill="#ccc" opacity=".13"/><circle cx="4" cy="3" r=".6" fill="#000" opacity=".22"/></pattern>
      </defs>
      <rect width="700" height="950" fill="#161a18"/>
      <path d="M-130 -100H500C520 170 450 280 392 429S328 678 445 1050H-130Z" fill="url(#facade)"/>
      <g stroke="#101513" fill="none" stroke-width="1.1" opacity=".8">
        <path v-for="n in 26" :key="'v'+n" :d="vertical(n)"/>
        <path v-for="n in 34" :key="'h'+n" :d="horizontal(n)"/>
      </g>
      <path d="M555 -80C770 310 723 590 618 725S545 947 612 1050H820V-80Z" fill="#4a4f4b"/>
      <g stroke="#111713" stroke-width="1" fill="none"><path v-for="n in 17" :key="'r'+n" :d="'M'+(540+n*13)+' -50 Q'+(780+n*2)+' 380 '+(570+n*12)+' 1000'"/></g>
      <rect width="700" height="950" fill="url(#grain)"/>
      <rect width="700" height="950" fill="url(#shadow)"/>
    </svg>
  </div>
</template>
<script>
export default {
  methods: {
    vertical (n) { const x = -100 + n * 25; return `M${x} -80 C${x + 24} 180 ${x - 92} 345 ${x - 105} 530 S${x - 35} 835 ${x + 42} 1030` },
    horizontal (n) { const y = -40 + n * 32; return `M-160 ${y} Q160 ${y + 145} 485 ${y - 15}` }
  }
}
</script>
<style scoped>.architecture{position:absolute;inset:0;overflow:hidden;background:#191c1a}.architecture svg{height:100%;width:100%;display:block;transform:scale(1.05)} </style>
